import React, { useEffect, useState } from 'react'
import './LoginStyle.css'
import InputField from '../../components/InputField/InputField'
import Button from '../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login, userSelector, clearState, forgotPassword } from "../../reducer/userSlice";
import ErrorToast from "../../components/Toast/ErrorToast";
import PageLoader from '../../components/loaders/PageLoader/PageLoader';
import SuccessToast from '../../components/Toast/SuccessToast';

const Dashboard = () => {
    
    const [type, setType] = useState(false);
    const [tabToggler, setTabToggler] = useState(1);
    
    //Login states
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    
    //Validation states
    const [emailValidation, setEmailValidation] = useState(false);
    const [passwordValidation, setPasswordValidation] = useState(false);

    //Forgot Pass states
    const [forgotEmail, setForgotEmail] = useState("");
    
    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    const [isShowSuccess, setIsShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    
    const navigate = useNavigate();

  const dispatch = useDispatch();
  const { isFetching, isSuccess, isError, errorMessage, route, forgotPassSuccess } =
    useSelector(userSelector);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailValidation("");
    setPasswordValidation("");
  }

  const handleForgotEmailChange = (e) => {
    setForgotEmail(e.target.value);
    setEmailValidation("");
    setPasswordValidation("");
  }

  const handlePassChange = (e) => {
    setEmailValidation("");
    setPasswordValidation("");

    const { value } = e.target;
    setPassword(value);

    if (!value) {
      setPasswordValidation("Please fill password");
    } else {
      setPasswordValidation("");
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !password) {
      setPasswordValidation("Please fill both fields!")
      //   setIsShowError(true);
      //   setErrMessage("Please fill both fields!")
    }
    else {
      const filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!filter.test(email)) {
        setEmailValidation("Please enter valid email");
        // setIsShowError(true);
        // setErrMessage("Please enter valid email");
      }
      else {
        setEmailValidation("");
        const object = {
          rememberMe,
          obj : {
            email: email,
            password: password
          }
        }
        dispatch(login(object))
      }
    }
  }

  const handleKeyPressSubmit = (e) => {
    if (e.key === "Enter" && !isFetching) {
      e.preventDefault();
      if (!email || !password) {
        setPasswordValidation("Please fill both fields!")
        // setIsShowError(true);
        // setErrMessage("Please fill both fields");
      } else {
        const filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!filter.test(email)) {
          setEmailValidation("Please enter valid email");
          //   setIsShowError(true);
          //   setErrMessage("Please enter valid email");
        }
        else {
          setEmailValidation("");
          const object = {
            rememberMe,
            obj : {
              email: email,
              password: password
            }
          }
          dispatch(login(object))
        }
      }
    }
  };

  const handleForgotPass = (e) => {
    e.preventDefault();
    if (!forgotEmail) {
      setEmailValidation("Please enter your email!");
    }
    else {
      const filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!filter.test(forgotEmail)) {
        setEmailValidation("Please enter valid email");
      }
      else {
        setEmailValidation("");
        const obj = {
            email: forgotEmail,
          }
        dispatch(forgotPassword(obj));
      }
    }
  }

  const handleForgotPassPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (!forgotEmail) {
        setEmailValidation("Please enter your email!");
      } else {
        const filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!filter.test(forgotEmail)) {
          setEmailValidation("Please enter valid email");
        }
        else {
          setEmailValidation("");
          const obj = {
              email: forgotEmail,
            }
          dispatch(forgotPassword(obj));
        }
      }
    }
  };

  useEffect(() => {
    setEmailValidation("");
    setPasswordValidation("");
  },[tabToggler])

  useEffect(() => {
    if (isError) {
      setIsShowError(true);
      setErrMessage(errorMessage);
      dispatch(clearState());
    }

    if (isSuccess) {
      navigate("/"+route, { replace: true });
      dispatch(clearState());
    }
    // eslint-disable-next-line
  }, [isError, isSuccess]);

  useEffect(() => {
    if(forgotPassSuccess) {
      setIsShowSuccess(true);
      setSuccessMessage("Please check your email for further instructions!");
      setTabToggler(1);
      dispatch(clearState());
    }
  },[forgotPassSuccess])

  return (
    <>
      {/* {isFetching && <PageLoader />} */}
      <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
      <SuccessToast
        show={isShowSuccess}
        setShow={() => setIsShowSuccess(false)}
        message={successMessage}
      />
      <div className={`loginmainwrapper ${tabToggler === 1 ? 'active' : ''}`}>
            <div className="dashboardWrapper">
                <img src="/assets/icons/logo.svg" alt="" className='logo' />
                <div className="dashLoginWrapper">
                    <div className="loginHeading">Welcome!</div>
                    <div className="loginText mt10">Hey, Enter your details to sign in to your account.</div>

                    <div className="inputFieldsBox">
                        <InputField
                            notImp={"notimp"}
                            placeholder={"Registered Email Id"}
                            name="email"
                            type={"text"}
                            img={'mail-02'}
                            value={email}
                            onChange={handleEmailChange}
                            onKeyDown={handleKeyPressSubmit}
                            errorMessage={emailValidation}
                        />
                        <InputField
                            notImp={"notimp"}
                            placeholder={"Password"}
                            name="emailID"
                            type={type ? 'text' : 'password'}
                            inputIcon={type ? 'viewIcon' : 'hideIcon'}
                            img={'lock'}
                            onEyeClick={() => setType(!type)}
                            value={password}
                            onChange={handlePassChange}
                            onKeyDown={handleKeyPressSubmit}
                            errorMessage={passwordValidation}
                        />
                    </div>

                    <div className="loginAddonsWrap">
                        <label className='checkboxNew' htmlFor="this">
                            <input type="checkbox" id='this' name='this' checked={rememberMe} onChange={() => setRememberMe(prev => !prev)} />
                            Remember Me
                        </label>

                        <div className="forgetLink pointer" onClick={() => setTabToggler(2)} >Forget Password</div>
                    </div>

                      <div className='flex-center loginButton'>
                          <Button className={'BlueFillButton mt40'} name={isFetching ? <div class="loaderbtnmain"> 
                <div class="dotbox"></div>
                <div class="dotbox"></div>
                <div class="dotbox"></div>
                <div class="dotbox"></div>
                <div class="dotbox"></div>
                
               </div> : 'Login'} onClick={handleSubmit} disabled={isFetching} />
                      </div>

                </div>
                <div className="copyrightText mt20">Copyright@getprepped | Privacy Policy</div>
            </div>
        </div>


      {/* Forgot Password */}
      
      <div className={`loginmainwrapper ${tabToggler === 2 ? 'active' : ''}`}>
        <div className="dashboardWrapper">
          <img src="/assets/icons/logo.svg" alt="" className='logo' />
          <div className="dashLoginWrapper">
            <div className="loginHeading">Forgot Password ?</div>
            <div className="loginText mt10">No worries! We will send you reset instructions </div>

            <div className="inputFieldsBox">
              <InputField
                notImp={"notimp"}
                placeholder={"Enter Registered Email Id"}
                type={"text"}
                img={'mail-02'}
                value={forgotEmail}
                onChange={handleForgotEmailChange}
                errorMessage={emailValidation}
                onKeyDown={handleForgotPassPress}
              />

            </div>

            <div className='flex-center loginButton'>
              <Button className={'BlueFillButton mt40'} name={'Reset Password'} onClick={handleForgotPass} />
            </div>

            <div className="Backbtnlogin" onClick={() => setTabToggler(1)} >
              <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.98375 10.0163L2.97625 6L6.98375 1.98375L5.75 0.75L0.5 6L5.75 11.25L6.98375 10.0163Z" fill="#737373" />
              </svg>
              Back to Login
            </div>

          </div>
          <div className="copyrightText mt20">Copyright@getprepped | Privacy Policy</div>
        </div>
      </div>

    </>
  )
}

export default Dashboard